class Map {
    constructor() {
        this.map = null;
        this.activeMarkers = [];
        this.infoWindow = null;
        this.markersData = backendData.mapData;
        this.markersDataInfrastructure = backendData.mapDataInfrastructure;
        this.filters = document.querySelectorAll('.map__filter');
        this.mapSection = document.querySelector('.map');

        this.init();
    }

    init() {
        this.initMap();
        this.handlePage();
        this.filtersHandle();
    }

    initMap() {
        this.map = new google.maps.Map(document.getElementById("map"), {
            zoom: 14,
            disableDefaultUI: false,
            styles: [
                {
                    elementType: "geometry",
                    stylers: [{color: "#eaeaea"}],
                },
                {
                    elementType: "labels.icon",
                    stylers: [{visibility: "off"}],
                },
                {
                    elementType: "labels.text.fill",
                    stylers: [{color: "#242424"}],
                },
                {
                    elementType: "labels.text.stroke",
                    stylers: [{color: "#f5f5f5"}],
                },
                {
                    featureType: "administrative",
                    elementType: "geometry",
                    stylers: [{color: "#242424"}],
                },
                {
                    featureType: "administrative.country",
                    elementType: "labels.text.fill",
                    stylers: [{color: "#616161"}],
                },
                {
                    featureType: "administrative.land_parcel",
                    stylers: [{visibility: "off"}],
                },
                {
                    featureType: "administrative.locality",
                    elementType: "labels.text.fill",
                    stylers: [{color: "#4b4b4b"}],
                },
                {
                    featureType: "poi",
                    elementType: "labels.text.fill",
                    stylers: [{color: "#242424"}],
                },
                {
                    featureType: "poi.business",
                    stylers: [{visibility: "off"}],
                },
                {
                    featureType: "poi.park",
                    elementType: "geometry",
                    stylers: [{color: "#eaeaea"}],
                },
                {
                    featureType: "poi.park",
                    elementType: "labels.text.fill",
                    stylers: [{color: "#3a3a3a"}],
                },
                {
                    featureType: "poi.park",
                    elementType: "labels.text.stroke",
                    stylers: [{color: "#f5f5f5"}],
                },
                {
                    featureType: "road",
                    elementType: "geometry.fill",
                    stylers: [{color: "#d6d6d6"}],
                },
                {
                    featureType: "road",
                    elementType: "labels.text.fill",
                    stylers: [{color: "#4e4e4e"}],
                },
                {
                    featureType: "road.arterial",
                    elementType: "geometry",
                    stylers: [{color: "#cfcfcf"}],
                },
                {
                    featureType: "road.highway",
                    elementType: "geometry",
                    stylers: [{color: "#c2c2c2"}],
                },
                {
                    featureType: "road.highway.controlled_access",
                    elementType: "geometry",
                    stylers: [{color: "#bfbfbf"}],
                },
                {
                    featureType: "road.local",
                    elementType: "labels.text.fill",
                    stylers: [{color: "#3e3e3e"}],
                },
                {
                    featureType: "transit",
                    elementType: "labels.text.fill",
                    stylers: [{color: "#242424"}],
                },
                {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [{color: "#ffffff"}],
                },
                {
                    featureType: "water",
                    elementType: "labels.text.fill",
                    stylers: [{color: "#8a8a8a"}],
                },
                {
                    featureType: "poi",
                    elementType: "labels",
                    stylers: [{visibility: "off"}]
                },
                {
                    featureType: "poi.business",
                    elementType: "all",
                    stylers: [{visibility: "off"}]
                }
            ],
        });
    }

    isExistOtherDomain(str) {
        const regex = /^[A-Za-z]{2}$/;
        return regex.test(str);
    }

    handlePage() {
        const urlPath = window.location.pathname;
        const segments = urlPath.split('/').filter(Boolean);

        const element = document.querySelector('.gm-style-iw-d');

        if(this.isExistOtherDomain(segments[0])) {
            segments.shift();
        }

        if (segments.length === 0) {
            this.showMarkers('work');
            if (element) {
                element.classList.add('new-class');
            }

        } else if (segments.length === 1) {
            // Category page (example: /work, /sleep, /meet)
            const category = segments[0];
            this.showMarkers(category);
        } else {
            const currentPostType = this.mapSection && this.mapSection.getAttribute('data-post-type');
            if (currentPostType) {
                this.showMarkers(currentPostType);
            }
        }
    }

    showMarkers(category) {
        this.activeMarkers.forEach((marker) => marker.setMap(null));
        this.activeMarkers = [];

        if (this.infoWindow) this.infoWindow.close();
        const locations = this.markersData[category];

        const categoryForListener = category;

        if (locations && locations.length > 0) {
            const firstLocation = locations[0];
            this.map.setCenter({
                lat: parseFloat(firstLocation.lat),
                lng: parseFloat(firstLocation.lng),
            });
        }

        locations?.forEach((location) => {

            const marker = new google.maps.Marker({
                position: {
                    lat: parseFloat(location.lat),
                    lng: parseFloat(location.lng),
                },
                map: this.map,
                title: location.title,
                icon: {
                    url: backendData.mapMarkerIcon,
                    scaledSize: new google.maps.Size(30, 30),
                },
            });

            marker.addListener("click", () => {
                if (this.infoWindow) this.infoWindow.close();

                let style;
                if(categoryForListener === 'work'){
                    style = `
                        <style>
                        .gm-style-iw-d { background: #849A64 !important; overflow: hidden !important;}
                        .gm-style-iw-chr { background: #849A64 !important; overflow: hidden !important;}
                        .gm-style-iw-ch { background: #849A64 !important; overflow: hidden !important;}
                        .gm-style-iw, .gm-style-iw-c { background: #849A64 !important; overflow: hidden !important;}
                        </style>
                    `;
                } else if(categoryForListener === 'sleep'){
                    style = `
                        <style>
                        .gm-style-iw-d { background: #C09C3C !important; overflow: hidden !important;}
                        .gm-style-iw-chr { background: #C09C3C !important; overflow: hidden !important;}
                        .gm-style-iw-ch { background: #C09C3C !important; overflow: hidden !important;}
                        .gm-style-iw, .gm-style-iw-c { background: #C09C3C !important; overflow: hidden !important;}
                        </style>
                    `;
                } else if(categoryForListener === 'meet'){
                    style = `
                        <style>
                        .gm-style-iw-d { background: #FAEDF1 !important; overflow: hidden !important;}
                        .gm-style-iw-chr { background: #FAEDF1 !important; overflow: hidden !important;}
                        .gm-style-iw-ch { background: #FAEDF1 !important; overflow: hidden !important;}
                        .gm-style-iw, .gm-style-iw-c { background: #FAEDF1 !important; overflow: hidden !important;}
                        </style>
                    `;
                }

                const infoContent = `
                    ${style}
                    <div class="map__location">
                      <p class="map__location-title">
                        <a href="${location.url}">${location.title}</a>
                      </p>
                      <p class="map__location-content">
                        ${location.content}
                      </p>
                    </div>
                  `;

                this.infoWindow = new google.maps.InfoWindow({
                    content: infoContent,
                    pixelOffset: new google.maps.Size(120, 10),
                });

                this.infoWindow.open(this.map, marker);
            });

            this.activeMarkers.push(marker);
        });

        this.markersDataInfrastructure && this.markersDataInfrastructure.forEach((location) => {
            const marker = new google.maps.Marker({
                position: {
                    lat: parseFloat(location.latitude),
                    lng: parseFloat(location.longitude),
                },
                map: this.map,
                title: location.title,
                icon: {
                    url: location.icon.url,
                    scaledSize: new google.maps.Size(30, 30),
                },
            });

            marker.addListener("click", () => {
                if (this.infoWindow) this.infoWindow.close();

                const style = `
                        <style>
                        .gm-style-iw-d { background: #FAEDF1 !important; overflow: hidden !important;}
                        .gm-style-iw-chr { background: #FAEDF1 !important; overflow: hidden !important;}
                        .gm-style-iw-ch { background: #FAEDF1 !important; overflow: hidden !important;}
                        .gm-style-iw, .gm-style-iw-c { background: #FAEDF1 !important; overflow: hidden !important;}
                        </style>
                    `;

                const infoContent = `
                    ${style}
                    <div class="map__location">
                      <p class="map__location-title">
                        ${location.title}
                      </p>
                      <p class="map__location-content">
                        ${location.content}
                      </p>
                    </div>
                  `;

                this.infoWindow = new google.maps.InfoWindow({
                    content: infoContent,
                    pixelOffset: new google.maps.Size(120, 10),
                });

                this.infoWindow.open(this.map, marker);
            });

            this.activeMarkers.push(marker);
        });
    }

    filtersHandle() {
        if (this.filters && this.filters.length > 0) {
            this.filters[0].classList.add('active');
            this.filters.forEach((filter, key) => {
                filter && filter.addEventListener("click", () => {
                    this.filters.forEach((item) => {
                        item.classList.remove('active');
                    });

                    filter.classList.add('active');
                    const dataFilter = filter.getAttribute('data-category');
                    this.showMarkers(dataFilter);
                });
            });
        }
    }
}

new Map();
